import { createAsyncThunk } from '@reduxjs/toolkit';
import { TSAService } from '@bvt-features/tenant-suitability/service/TSAService';
import { STORE_PREFIX } from '@bvt-features/tenant-suitability/constant/STORE_PREFIX';
import { assetActions } from './asset.slice';
import { KategoriService } from '@bvt-features/genset/poi/service/kategori';
import axios from 'axios';
import { throttle } from 'lodash';

const tsaService = new TSAService();
const kategoriService = new KategoriService();

export const getListAsset = createAsyncThunk(
  `${STORE_PREFIX}/getListAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getListAsset(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailAsset = createAsyncThunk(
  `${STORE_PREFIX}/getDetailAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getDetailAsset(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadAssetList = createAsyncThunk(
  `${STORE_PREFIX}/doDownloadAssetList`,
  async (param, { rejectWithValue, dispatch }) => {
    try {
      const resp = await tsaService.downloadAssetList(
        param,
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          dispatch(assetActions.setDownloadTotalSize(progressEvent.total));
          dispatch(assetActions.setDownloadLoadedSize(progressEvent.loaded));
          dispatch(assetActions.setDownloadProgress(progress));
        }
      );
      const base64Data = resp.file;
      const uint8Array = new Uint8Array(
        atob(base64Data)
          .split('')
          .map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([uint8Array], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const filename = resp.filename;
      return { url, filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUpdateAsset = createAsyncThunk(
  `${STORE_PREFIX}/createUpdateAsset`,
  async (param, { rejectWithValue }) => {
    try {
      return await tsaService.createUpdateAsset(param);
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

/**
 * @param {string} param
 */
export const doDeleteAsset = createAsyncThunk(
  `${STORE_PREFIX}/doDeleteAsset`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.deleteAsset(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @param {string} param
 */

export const getRukoListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getRukoListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getRukoList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTenantListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getTenantListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getTenantList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPOIListDetail = createAsyncThunk(
  `${STORE_PREFIX}/getPOIListDetail`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getPOIList(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatusAnalysisAsset = createAsyncThunk(
  `${STORE_PREFIX}/getStatusAnalysisAsset`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getStatusAsset();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getKategoriList = createAsyncThunk(
  `${STORE_PREFIX}/getKategoriList`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await kategoriService.getAll();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNewTenantList = createAsyncThunk(
  `${STORE_PREFIX}/getNewTenantList`,
  async (_, { rejectWithValue }) => {
    try {
      const resp = await tsaService.getNewTenantList();
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeNewTenant = createAsyncThunk(
  `${STORE_PREFIX}/removeNewTenant`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.removeNewTenant(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNewTenant = createAsyncThunk(
  `${STORE_PREFIX}/createNewTenant`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.cerateNewTenants(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const bulkDownloadResult = createAsyncThunk(
  `${STORE_PREFIX}/bulkDownloadResult`,
  async (param, { rejectWithValue, dispatch }) => {
    try {
      let isComplate = false;

      if (param?.status === 'error') {
        throw { message: param.message };
      }

      const throttledProgress = throttle((loaded, total) => {
        const progress = Math.round((loaded / total) * 100);
        dispatch(assetActions.setDownloadTotalSize(total));
        dispatch(assetActions.setDownloadLoadedSize(loaded));
        dispatch(assetActions.setDownloadProgress(progress));
      }, 500);

      const resp = await axios.get(param.url, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (isComplate) {
            return;
          }

          throttledProgress(progressEvent.loaded, progressEvent.total ?? 1);
        },
      });

      isComplate = true;
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      return { url, filename: param.filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadBulkResultXls = createAsyncThunk(
  `${STORE_PREFIX}/doDownloadBulkResultXls`,
  async (param, { rejectWithValue }) => {
    try {
      const resp = await tsaService.doBulkDownloadResultXls(param);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
